import { render } from "./PageCount.vue?vue&type=template&id=12fb0208&scoped=true"
import script from "./PageCount.vue?vue&type=script&lang=js"
export * from "./PageCount.vue?vue&type=script&lang=js"

import "@/assets/css/PageCount.scss?vue&type=style&index=0&id=12fb0208&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fb0208"]])

export default __exports__